import styled from '@emotion/styled';

export const WithHeaderContainer = styled('div')`
  display: grid;
  height: 100vh;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    'header'
    'main'
    'footer';

  .header {
    grid-area: header;
  }
  .main {
    grid-area: main;
  }
  .footer {
    grid-area: footer;
  }
`;
